const fr = {
  "Go back home": "Retour à la page d'accueil",
  "Oops! An unexpected error occurred.":
    "Oups! Une erreur inattendue est survenue.",
  "Our team has been notified and will look into it. Feel free to try again later.":
    "Notre équipe a été notifiée et va s'en occuper. N'hésitez pas à réessayer plus tard.",
  "Share your feedback": "Partager votre avis",
  "Page Not Found": "Page non trouvée",
  "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.":
    "La page que vous recherchez a peut-être été supprimée, ou son nom a changé, ou est temporairement indisponible.",
  "Last 24 hours": "Dernières 24 heures",
  "Last 7 days": "Derniers 7 jours",
  "Last 30 days": "Derniers 30 jours",
  "Last 3 months": "Derniers 3 mois",
  "Last 12 months": "Derniers 12 mois",
  "Select a period": "Choisir une période",
  All: "Depuis le début",
  "All (with days)": "Depuis le début ({{days}} jours)",
  "No results.": "Aucun résultat.",
};

const en = {
  "All (with days)": "All ({{days}} days)",
};

// This is the list of languages your application supports
export const supportedLngs = ["fr", "en"];

// This is the language you want to use in case
// if the user language is not in the supportedLngs
export const fallbackLng = "en";

// The default namespace of i18next is "translation", but you can customize it
// here
export const defaultNS = "translation";

export const createResources = (
  translations: Record<"en" | "fr", Record<string, string>>,
) => {
  return {
    en: { translation: { ...en, ...translations.en } },
    fr: { translation: { ...fr, ...translations.fr } },
  };
};

export default {
  supportedLngs,
  fallbackLng,
  defaultNS,
};
